import React, { useState } from 'react'
import styles from './FieldProperty.module.css'
import { Collapse } from 'antd'
import {
  SvgCollapseOpen,
  SvgCollapseClose,
} from '../../../../../../components/svg/SvgComponents'

const { Panel } = Collapse

const FieldProperty = React.memo(function FieldProperty({
  name,
  label,
  value,
  title,
  onChange,
  Component,
}) {
  const panelKey = `panel-${label}`
  return (
    <Collapse
      bordered={false}
      defaultActiveKey={[]}
      // defaultActiveKey={['1']}
      className={styles.the_collapse}
      expandIcon={({ isActive }) =>
        isActive ? <SvgCollapseOpen /> : <SvgCollapseClose />
      } // Ajoutez cette ligne
    >
      <Panel
        header={<div className={styles.custom_header}>{title}</div>}
        key={panelKey}
      >
        <div className={styles.container}>
          <div className={styles.input}>
            <Component
              label={label}
              name={name}
              value={value}
              onChange={onChange}
            />
          </div>
          <div className={styles.container__flex}>
            <div className={styles.divider}></div>
          </div>
        </div>
      </Panel>
    </Collapse>
  )
})

export default FieldProperty
